import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { all_routes } from "../../../router/all_routes";
import { useT } from "../../../../core/i18n";
import Api from "../../../../core/data/redux/utils/apiCall";
import { fetchSwfFormConfig, findOneSwf } from "./staffWelfare.service";
import SwfDetailsBody from "./SwfDetailsBody";

const ViewStaffWelfare: React.FC = () => {
  const { t } = useT();
  const routes = all_routes;
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const purposeFromQuery = searchParams.get("purpose") || "";

  const [detail, setDetail] = useState<any>(null);
  const [formConfig, setFormConfig] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const recordId = id ? decodeURIComponent(id) : "";

  useEffect(() => {
    const load = async () => {
      if (!recordId) {
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const data = await findOneSwf({ id: recordId });
        setDetail(data);
        const purpose = purposeFromQuery || data?.purpose || "";
        if (purpose) {
          try {
            setFormConfig(await fetchSwfFormConfig(purpose));
          } catch {
            setFormConfig(null);
          }
        }
      } catch (err: any) {
        setDetail(null);
        toast.error(Api.getErrorMessage(err) || t("failed_to_load_details"));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [recordId, purposeFromQuery, t]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">
              {t("display_staff_welfare_fund") === "display_staff_welfare_fund"
                ? "Display Application for Staff Welfare Fund"
                : t("display_staff_welfare_fund")}
            </h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={routes.staffWelfareFund.list}>{t("staff_welfare_fund_grants")}</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {t("view_details")}
                </li>
              </ol>
            </nav>
          </div>
          <Link to={routes.staffWelfareFund.list} className="btn btn-light">
            {t("cancel")}
          </Link>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-danger" role="status" />
          </div>
        ) : !detail ? (
          <div className="card border-0 shadow-sm">
            <div className="card-body text-center py-5 text-muted">{t("no_records_found")}</div>
          </div>
        ) : (
          <SwfDetailsBody detail={detail} formConfig={formConfig} />
        )}
      </div>
    </div>
  );
};

export default ViewStaffWelfare;
